module.exports = __webpack_public_path__ + "media/packs/images/flags/NA-89d18f0f30c102632f5c9651b5fef199.png";